/**
 * Supplier Payment enums and display labels for the Rebates module
 *
 * These are shared between backend and frontend to ensure consistency.
 */

/**
 * Types of supplier payments for rebates
 */
export enum RebateSupplierPaymentType {
  CHECK = "check",
  WIRE_TRANSFER = "wire_transfer",
  CREDIT_NOTE = "credit_note",
  AP_DEDUCTION = "ap_deduction",
}

/**
 * Display labels for RebateSupplierPaymentType
 */
export const REBATE_SUPPLIER_PAYMENT_TYPE_LABELS: Record<
  RebateSupplierPaymentType,
  string
> = {
  [RebateSupplierPaymentType.CHECK]: "Check",
  [RebateSupplierPaymentType.WIRE_TRANSFER]: "Wire Transfer",
  [RebateSupplierPaymentType.CREDIT_NOTE]: "Credit Note",
  [RebateSupplierPaymentType.AP_DEDUCTION]: "AP Deduction",
};

/**
 * Types of payment allocations
 */
export enum RebateSupplierPaymentAllocationType {
  MANUAL = "manual",
  AUTO = "auto",
  REMITTANCE_BASED = "remittance_based",
}

/**
 * Display labels for RebateSupplierPaymentAllocationType
 */
export const REBATE_SUPPLIER_PAYMENT_ALLOCATION_TYPE_LABELS: Record<
  RebateSupplierPaymentAllocationType,
  string
> = {
  [RebateSupplierPaymentAllocationType.MANUAL]: "Manual",
  [RebateSupplierPaymentAllocationType.AUTO]: "Auto",
  [RebateSupplierPaymentAllocationType.REMITTANCE_BASED]: "Remittance Based",
};
